import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=d431e698&scoped=true"
import script from "./helpCenter.vue?vue&type=script&lang=js"
export * from "./helpCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d431e698",
  null
  
)

export default component.exports